'use client';

import { useEffect, useState } from 'react';
import { captureClientError } from '@/lib/observability/client-error-reporter';
import { useLocale } from '@/components/LocaleProvider';
import ru from '@/i18n/common/ru.json';
import kk from '@/i18n/common/kk.json';
import en from '@/i18n/common/en.json';

export default function AppError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const { locale } = useLocale();
  const copy = { ru, kk, en }[locale].observability;
  const [eventId] = useState(() => crypto.randomUUID());
  useEffect(() => {
    captureClientError(error, { eventId, title: 'React render error', errorCode: error.digest ?? 'REACT_RENDER_ERROR' });
  }, [error, eventId]);
  return (
    <main className="min-h-screen bg-bg text-text grid place-items-center p-6">
      <section className="w-full max-w-md rounded-3xl border border-border bg-surface p-6 text-center shadow-sm">
        <h1 className="text-xl font-bold">{copy.crash_title}</h1>
        <p className="mt-2 text-muted">{copy.crash_body}</p>
        <p className="mt-4 font-mono text-sm">{copy.error_code.replace('{{code}}', eventId.slice(0, 8).toUpperCase())}</p>
        <div className="mt-6 grid gap-3">
          <button className="rounded-2xl bg-primary px-4 py-3 font-bold text-on-primary" onClick={reset}>{copy.retry}</button>
          <button className="rounded-2xl border border-border px-4 py-3 font-bold" onClick={() => (window.Telegram?.WebApp as unknown as { close?: () => void } | undefined)?.close?.()}>{copy.close}</button>
        </div>
      </section>
    </main>
  );
}
